import * as React from 'react';

interface Itab {
    // nametab:string,
    // index: number,
    // collapse: boolean,
    // Height?: number,
    // Width?: number,
    // OnCollapse?: (index: string) => void
    // saveNameFromSvg: (namemnemo?: any) => void,
    shConfig: any;
    mnemoInfoToSave: any;
    allMnemos: any;
    onNameInputChange: (namemnemo: string, close?: boolean, item?: string) => void;
    // onNameMnemoSave?: (namemnemo: any, item: string, subname: string, binding?: string) => void;
}

interface CloseTabState {
    name: string;
    id: number;
}

interface Data {
    name: string;
    item: string;
    id: number;
}
//блокировка закрытия табов, пока irame не загрузился
let iframeContentLoaded = false;

function MainWindowTab(props: Itab) {
    const { shConfig, mnemoInfoToSave, allMnemos } = props;

    const [width, setWidth] = React.useState(370);
    const [currentTab, setCurrentTab] = React.useState<Data>({ name: '', item: '', id: 1 });
    const [closeTab, setCloseTab] = React.useState<CloseTabState>({ name: '', id: 0 });
    const [arrayTab, setArrayTab] = React.useState<
        { id: number; name: any; item: string; subname: string; key: string }[]
    >([]);
    const countMnemo = shConfig.Display.FullScreenMode.NumberOfFrames;

    const NameMnemoSave = (namemnemo: any, item: string, subname: string, binding?: string) => {
        const key = generateUniqueKey();

        setArrayTab((TempTabs) => {
            const name = namemnemo;
            const isNameAlreadyExists = TempTabs.some((tab) => tab.name === name && tab.item === item);
            let updatedTabs = [...TempTabs];

            if (isNameAlreadyExists) {
                const existingTabIndex = TempTabs.findIndex((tab) => tab.name === name);
                const newSelectedTab = TempTabs[existingTabIndex];

                if (newSelectedTab.item !== item) {
                    updatedTabs[existingTabIndex] = { ...newSelectedTab, item, subname, key };
                }

                setCurrentTab({ name, item, id: newSelectedTab.id });
            } else if (name !== '') {
                const newItem = { id: countMnemo, name, item, subname, key };

                if (TempTabs.length >= countMnemo) {
                    if (TempTabs[countMnemo - 1].name === currentTab.name && countMnemo != 1) {
                        const indexToRemove = updatedTabs.findIndex((tab) => tab.id === currentTab.id + 1);
                        if (indexToRemove !== -1) {
                            updatedTabs.splice(indexToRemove, 1);
                        }
                    } else {
                        updatedTabs.pop();
                    }
                }

                updatedTabs.unshift(newItem);
                setCurrentTab({ name, item, id: countMnemo });
            }

            updatedTabs = updatedTabs.map((tab, index) => ({
                ...tab,
                id: countMnemo - index
            }));

            return updatedTabs;
        });
    };

    function generateUniqueKey(): string {
        return `${Date.now()}${Math.random().toString(36).substr(2, 9)}`;
    }

    React.useEffect(() => {
        NameMnemoSave(
            mnemoInfoToSave.mnemoname,
            mnemoInfoToSave.item,
            mnemoInfoToSave.subname,
            mnemoInfoToSave.binding
        );
        iframeContentLoaded = true;
    }, [mnemoInfoToSave]);

    //Таб для алармов
    React.useEffect(() => {
        const OpenTrendOrAlarm = (event: any) => {
            const name = event.detail.name;
            const item = event.detail.item;

            NameMnemoSave(name, item, '');
            props.onNameInputChange(name, item);
            iframeContentLoaded = true;
        };

        const closeAllMnemo = () => {
            setArrayTab([]);
            clearIframeContents('mainframe');
        };

        document.addEventListener('OpenTrendOrAlarm', OpenTrendOrAlarm);
        document.addEventListener('closeAllMnemo', closeAllMnemo);

        return () => {
            document.removeEventListener('OpenTrendOrAlarm', OpenTrendOrAlarm);
            document.removeEventListener('closeAllMnemo', closeAllMnemo);
        };
    }, []);

    const TabClick = (name: string, item: string, id: number) => {
        const newTabData = { name, item, id };

        setCurrentTab((prevState) => ({ ...prevState, ...newTabData }));

        if (
            name === '.AL Process Alarm' ||
            name === '.SA System Alarm Message' ||
            name === '.OG Operator Guide Message'
        ) {
            iframeContentLoaded = true;
            props.onNameInputChange(name, false, item);
        } else if (item.includes('CentumVPTrends')) {
            const nameArr = name.split(' ');
            const Block = nameArr[0].toUpperCase();
            const Group = nameArr[1].toUpperCase();
            window.OpenMnemo(`CentumVPTrends?BLOCK=${Block}&GROUP=${Group}`);
        } else {
            window.OpenMnemo(name);
        }
    };

    React.useEffect(() => {
        const updatedTabs = arrayTab.filter((tab) => tab.id !== closeTab.id);

        const reIndexedTabs = updatedTabs.map((tab, index) => ({
            ...tab,
            id: countMnemo - index
        }));

        setArrayTab(reIndexedTabs);

        const nextTab = reIndexedTabs.find((tab) => tab.id === closeTab.id);
        const previousTab = reIndexedTabs.find((tab) => tab.id === closeTab.id + 1);

        if (currentTab.id === closeTab.id) {
            iframeContentLoaded = false;
            if (nextTab) {
                TabClick(nextTab.name, nextTab.item, nextTab.id);
            } else if (previousTab) {
                TabClick(previousTab.name, previousTab.item, previousTab.id);
            } else if (closeTab.name.includes('group')) {
                setTimeout(() => {
                    if (window.ReactRoot) {
                        window.ReactRoot.unmount();
                    }
                }, 0);
                clearIframeContents('mainframe');
            } else {
                props.onNameInputChange('');
            }
        } else {
            setCurrentTab((prevState) => ({
                ...prevState,
                id: prevState.id > closeTab.id ? prevState.id : prevState.id + 1
            }));
        }
    }, [closeTab]);

    //Вычисление размеров табов
    React.useEffect(() => {
        const tabDiv = document.querySelector('.centumvp-window-tab');
        if (tabDiv instanceof HTMLElement) {
            const divWidth = tabDiv.offsetWidth;
            if (arrayTab.length > 3) {
                const TabWidth = divWidth / arrayTab.length;
                setWidth(TabWidth);
            } else {
                setWidth(370);
            }
        }
    }, [arrayTab]);

    //Очистка iframe, если табов нет
    const clearIframeContents = (iframeId: string) => {
        const iframe = document.getElementById(iframeId) as HTMLIFrameElement;

        if (iframe) {
            const iframeDocument = iframe.contentDocument;

            if (iframeDocument) {
                const bodyElement = iframeDocument.querySelector('body');

                if (bodyElement) {
                    props.onNameInputChange('');
                    bodyElement.innerHTML = '';
                }
            }
        }
    };

    function handleCloseTab(name: string, id: number) {
        setCloseTab({ name: name, id: id });
    }

    return (
        <>
            <div className="centumvp-window-tab">
                {arrayTab.map((tab, i) => (
                    <div
                        key={tab.key}
                        id={tab.id.toString()}
                        className={`tab ${currentTab.name === tab.name && currentTab.item === tab.item ? 'active' : ''}`}
                        title={`${tab.subname != undefined && tab.subname != '' ? tab.subname : tab.name}`}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            id="svg_content"
                            x="700"
                            y="510.25"
                            viewBox={`0 0 ${width} 15`}
                            transform="matrix(1,0,0,1,0,0)"
                            preserveAspectRatio="none"
                            style={{
                                cursor: 'default',
                                width: '100%',
                                height: '25px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}>
                            {/* <g transform="matrix(1,0,0,1,0,0)" id="left" onClick={() => TabClick(tab.name, tab.item)} onMouseDown={(event) => {if (event.button === 1) {TabClose(tab.name, tab.id);}}}> */}
                            <g
                                transform="matrix(1,0,0,1,0,0)"
                                id="left"
                                onClick={() => TabClick(tab.name, tab.item, tab.id)}
                                onMouseDown={(event) => {
                                    if (event.button === 1) {
                                        if (iframeContentLoaded) {
                                            handleCloseTab(tab.name, tab.id);
                                        }
                                        // closeTab(tab.id, currentTab.id)
                                    }
                                }}>
                                <g className="rect-group">
                                    <rect
                                        transform="matrix(1,0,0,1,0,5)"
                                        id="rect1"
                                        className="rect"
                                        width={width + 'px'}
                                        height="10"
                                    />
                                    <rect
                                        transform="matrix(1,0,0,1,0,0)"
                                        id="rect2"
                                        className="rect"
                                        width={width + 'px'}
                                        height="10"
                                        rx="6"
                                        ry="6"
                                    />
                                </g>
                            </g>
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" id="svg_text" preserveAspectRatio="none">
                            <linearGradient id="circleGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                                <stop offset="0%" style={{ stopColor: '#eaf4dd' }} />
                                <stop offset="100%" style={{ stopColor: '#cae385' }} />
                            </linearGradient>
                            <circle cx="16" cy="13" r="7" fill="url(#circleGradient)" stroke="#28488a" />
                            <text x="30" y="18" fill="black">
                                {tab.subname != undefined && tab.subname != '' ? tab.subname : tab.name}{' '}
                                {tab.item != 'CentumVPTrends' ? tab.item : ''}
                            </text>
                        </svg>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            id="cross"
                            viewBox="-1 4 16 16"
                            onClick={() => {
                                if (iframeContentLoaded) {
                                    handleCloseTab(tab.name, tab.id);
                                }
                            }}>
                            {/* onClick={() => closeTab(tab.id, currentTab.id)}> */}
                            <g className="closeButton" transform="matrix(1,0,0,1,-200,9)" id="right">
                                <line id="line2" transform="matrix(1,0,0,1,213,-3)" x2="-12" y2="12" />
                                <line id="line3" transform="matrix(1,0,0,1,201,-3)" x2="12" y2="12" />
                            </g>
                        </svg>
                    </div>
                ))}
            </div>
        </>
    );
}

export default MainWindowTab;
